import { createSlice } from "@reduxjs/toolkit";

const normalizeToastMessage = (message) => {
  if (typeof message === "string") return message;
  if (message === null || message === undefined) return "An error occurred.";

  if (Array.isArray(message)) {
    return message
      .map((item) => {
        if (typeof item === "string") return item;
        const field = Array.isArray(item?.loc) ? item.loc[item.loc.length - 1] : null;
        return field ? `${field}: ${item.msg || item.message || ""}` : item.msg || item.message || "";
      })
      .filter(Boolean)
      .join(" | ");
  }

  if (typeof message === "object") {
    if (typeof message.detail === "string") return message.detail;
    if (message.detail) return normalizeToastMessage(message.detail);
    if (typeof message.message === "string") return message.message;
    try {
      return JSON.stringify(message);
    } catch {
      return "An error occurred.";
    }
  }

  return String(message);
};

// success, error, info, warning
const toastSlice = createSlice({
  name: "toast",
  initialState: {
    message: "",
    type: "", 
    show: false,
  },
  reducers: {
    showToast: (state, action) => {
      state.message = normalizeToastMessage(action.payload?.message);
      state.type = action.payload?.type || "info";
      state.show = true;
    },
    hideToast: (state) => {
      state.show = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;